import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import NotFound from "@/pages/common/NotFound";
import { NonIndexRouteConfig, RouteConfig } from ".";

const wrapProtectedRoute = (route: RouteConfig): RouteObject => {
	const { element, children, ...rest } = route as NonIndexRouteConfig;

	if (children) {
		return {
			...rest,
			element: <ProtectedRoute>{element || <Layout />}</ProtectedRoute>,
			children: [
				...children.map(wrapProtectedRoute),
				{
					path: "*",
					element: <NotFound />
				}
			]
		};
	}

	return {
		...rest,
		element: <ProtectedRoute>{element}</ProtectedRoute>
	};
};

export const generateRoutes = (
	publicRoutes: RouteConfig[],
	protectedRoutes: RouteConfig[],
	isAuthenticated: boolean
): RouteObject[] => {
	const wrappedProtectedRoutes = protectedRoutes.map(wrapProtectedRoute);

	const processedPublicRoutes = publicRoutes.map(
		(route): RouteObject => ({
			...route,
			element:
				isAuthenticated && route.path === "/login" ? (
					<Navigate to="/admin/brands" replace />
				) : (
					route.element
				)
		})
	);

	// Public catch-all route for non-authenticated users
	const publicNotFoundRoute: RouteObject = {
		path: "*",
		element: isAuthenticated ? (
			<Navigate to="/admin/brands" replace />
		) : (
			<NotFound />
		)
	};

	return [
		...processedPublicRoutes,
		...wrappedProtectedRoutes,
		publicNotFoundRoute
	];
};
